/* @flow */

import Immutable from 'immutable';
import { bindSelectors, memoizeSelectors } from './selectors';

const Selectors = {
  getViewport(state: Immutable.Map): Immutable.Map {
    return state.get('viewport');
  },
  getCenter(state: Immutable.Map): number {
    return state.getIn(['viewport', 'center']);
  },
  getZoom(state: Immutable.Map): number {
    return state.getIn(['viewport', 'zoom']);
  },
  getBearing(state: Immutable.Map): number {
    return state.getIn(['viewport', 'bearing']);
  },
  getPitch(state: Immutable.Map): number {
    return state.getIn(['viewport', 'pitch']);
  },
  getMarkerHoverId(state: Immutable.Map): number {
    return state.getIn(['marker', 'hoverId']);
  },
  getPopup(state: Immutable.Map): Immutable.Map {
    return state.get('popup');
  },
  getActions(state: Immutable.Map): Immutable.Map {
    return state.get('actions');
  },
};

const UnboundMapSelectors = memoizeSelectors(Selectors);
const MapSelectors = bindSelectors('map', UnboundMapSelectors);

export {
  MapSelectors,
  UnboundMapSelectors
};
